// eslint-disable-next-line unused-imports/no-unused-imports
import twix from "twix";

const createMomentRange = range => range[0].twix(range[1]);

export default createMomentRange;
